<template>
  <div>
    <div class="intelligentBox box-shadow" v-show="!showEffectAnalysisX">
      <div class="global-title">智能营销</div>
      <!-- tab切换栏 -->
      <div class="tab-line">
        <div
          class="tab-item"
          @click="handleSwitch(1)"
          :class="{ active: tabIndex == '1' }"
          :style="{
            color: tabIndex == '1' ? globalBG : '',
            'border-top': tabIndex == '1' ? '2px solid ' + globalBG : '',
          }"
        >
          智能营销
          <span></span>
        </div>
        <div
          class="tab-item"
          @click="handleSwitch(2)"
          :class="{ active: tabIndex == '2' }"
          :style="{
            color: tabIndex == '2' ? globalBG : '',
            'border-top': tabIndex == '2' ? '2px solid ' + globalBG : '',
          }"
        >
          短信记录
          <span></span>
        </div>
        <div
          class="tab-item"
          @click="handleSwitch(3)"
          :class="{ active: tabIndex == '3' }"
          :style="{
            color: tabIndex == '3' ? globalBG : '',
            'border-top': tabIndex == '3' ? '2px solid ' + globalBG : '',
          }"
        >
          营销效果
          <span></span>
        </div>
      </div>
      <!-- 推荐模板 -->
      <div class="recom-template" v-if="tabIndex == 1">
        <div class="recom-title">
          <span class="divison"></span>
          <span class="name">推荐模板</span>
          <span class="open" @click="isShowAll = !isShowAll">{{isShowAll? '收起': '展开'}}</span>
        </div>
        <div class="recom-list" :style="{'max-height': isShowAll? '100%': '344px'}">
          <div class="recom-item" v-for="(item, index) in recommondList" :key="index">
            <div class="recom-content">
              <div class="img-wrap">
                <img v-if="item.iconUrl" :src="item.iconUrl" alt="">
                <img v-else src="@/assets/images/recom_default.png" alt="">
              </div>
              <div class="text-info">
                <p class="title">{{item.name}}</p>
                <p class="info">{{item.description}}</p>
              </div>
            </div>
            <div class="create-btn" @click="newBtn(index)">立即创建</div>
          </div>
        </div>
      </div>
      <!-- 短信记录 -->
      <sms-record-form v-if="tabIndex == '2'"></sms-record-form>
      <!-- 营销效果 -->
      <effect-market-form @showEffect="showEffectX" v-if="tabIndex == '3'"></effect-market-form>

      <!-- 智能营销 -->
      <div v-if="tabIndex == '1'" style="margin-top: 10px">
        <div class="tab_item_box">
          <div>
            <span class="create_btn3" @click="newBtn()">
              <img
                src="@/assets/images/member/new_establish.png"
                style="
                  display: inline-block;
                  float: left;
                  width: 14px;
                  height: 14px;
                  color: #ffffff;
                  margin: 9px -6px 0px 12px;
                "
              />
              新建活动
            </span>
            <div class="right_allBtn">
              活动名称:
              <el-input
                v-model="queryForm.activityName"
                placeholder="请输入任务名称"
                style="width: 280px; margin: 0 5px 0 8px"
              ></el-input>
              <el-button
                icon="el-icon-search"
                class="status_btn"
                :disabled="tableLoading"
                @click="handleSearch"
                >查询</el-button
              >
              <!-- <el-button class="status_btn status_btn2" @click="resetBtn1"
                >重置</el-button
              > -->
            </div>
          </div>
        </div>
        <div class="tab_item_box_one">
          <el-tabs v-model="activeStatus" @tab-click="handleClick">
            <el-tab-pane label="全部" name="-1"></el-tab-pane>
            <el-tab-pane label="设计中" name="0"></el-tab-pane>
            <el-tab-pane label="执行中" name="1"></el-tab-pane>
            <el-tab-pane label="已结束" name="2"></el-tab-pane>
          </el-tabs>
        </div>
        <!-- 表格内容 -->
        <div class="table-center">
          <el-table
            :data="tableData"
            v-loading="tableLoading"
            style="width: 100%"
            :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
          >
            <el-table-column label="活动ID" width="80">
              <template slot-scope="scope">
                <span>{{ scope.row.id }}</span>
              </template>
            </el-table-column>
            <el-table-column label="活动名称">
              <template slot-scope="scope">
                <span>{{ scope.row.activityName }}</span
                ><i
                  class="el-icon-edit-outline"
                  @click="handleName(scope.$index, scope.row)"
                ></i>
              </template>
            </el-table-column>
            <el-table-column label="执行方式">
              <template slot-scope="scope">
                <span v-if="scope.row.executionType==0">立即执行</span>
                <span v-else>{{ scope.row.executionType | showExecution }}</span>
              </template>
            </el-table-column>
            <el-table-column label="启动时间">
              <template slot-scope="scope">
                <span>{{ scope.row.startUpTime }}</span>
              </template>
            </el-table-column>
            <el-table-column label="执行时间">
              <template slot-scope="scope">
                <div v-if="scope.row.executionType === 2">
                  <p>上次 {{scope.row.executionDate || '--'}} </p>
                  <p>下次 {{scope.row.nextExecutionDate || '--'}}</p>
                </div>
                <div v-else>
                  {{scope.row.executionDate || '--'}}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="活动状态">
              <template slot-scope="scope">
                <span>{{ scope.row.activityStatus | showStatus }}</span>
                  <el-tooltip v-if='scope.row.cycleExecutionDatetimeList' placement="top">
                    <div slot="content" v-html="scope.row.cycleExecutionDatetimeList.join('，')"></div>
                    <span><i class="el-icon-warning"></i></span>
                  </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="230">
              <template slot-scope="scope">
                <template>
                  <el-button
                    size="small"
                    style="width: 60px"
                    type="text"
                    class="operation"
                    @click="handleView(scope.$index, scope.row)"
                    >查看</el-button
                  >
                  <el-button
                    size="small"
                    type="text"
                    style="width: 60px"
                    class="operation"
                    @click="handleSaveAs(scope.$index, scope.row)"
                    >另存</el-button
                  >
                  <el-button
                    size="small"
                    style="width: 60px"
                    type="text"
                    @click="handleDelete(scope.$index, scope.row)"
                    >删除</el-button
                  >
                </template>
                <!-- <template v-else> -->
                <!-- <el-button
                    size="mini"
                    @click="handleEdit(scope.$index, scope.row)"
                    type="danger"
                    >设计</el-button
                  > -->
                <!-- <el-button
                    size="small"
                    type="danger"
                    @click="handleSaveAs(scope.$index, scope.row)"
                    >另存</el-button
                  >
                  <el-button
                    size="small"
                    type="danger"
                    @click="handleDelete(scope.$index, scope.row)"
                    >删除</el-button
                  > -->
                <!-- </template> -->
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            background
            style="text-align: right; margin: 20px -10px 0px 0px"
            small
            layout="total, prev, pager, next"
            :current-page.sync="queryForm.current"
            :page-size="queryForm.pageSize"
            :total="queryForm.total"
            @current-change="queryCurrentChange"
          >
          </el-pagination>
          <!-- 新建活动 -->
          <el-dialog
            title="新建活动"
            :visible.sync="dialogCampaignVisible"
            :close-on-click-modal="false"
            :append-to-body="false"
            @close="newFormClose"
          >
            <el-form :model="formCampaign" ref="formCampaign" :rules="rules">
              <el-form-item
                label="活动名称"
                prop="activityName"
                :label-width="formLabelWidth"
              >
                <el-input
                  v-model="formCampaign.activityName"
                  autocomplete="off"
                  maxlength="20"
                >
                  <span
                    slot="suffix"
                    style="
                      position: relative;
                      bottom: 0;
                      right: 0;
                      color: rgba(153, 153, 153, 1);
                      margin-right: 10px;
                    "
                    >{{ formCampaign.activityName.length }}/20</span
                  >
                </el-input>
              </el-form-item>
              <el-form-item label="活动模板" :label-width="formLabelWidth">
                <div style="text-align: left">
                  <el-radio-group
                    v-model="formCampaign.templateType"
                    @change="typeTemplateChange"
                  >
                    <el-radio label="">空白模板</el-radio>
                    <el-radio :label="1">系统模板</el-radio>
                    <el-radio :label="2">自定义模板</el-radio>
                  </el-radio-group>
                </div>
                <div style="text-align: left; margin-top:8px">
                  <div
                    v-if="templateList.length"
                    class="templist"
                    v-loading="tempLoading"
                    element-loading-text="模板加载中"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(0, 0, 0, 0.8)"
                  >
                    <div
                      class="titem"
                      v-for="(item, index) in templateList"
                      :key="item.value"
                      @click.stop="selectTemplate(index)"
                      :class="{ active: item.selected }"
                      :style="{ background: item.selected ? globalBG : '' }"
                    >
                      <span>{{ item.name }}</span>
                      <el-button
                        v-show="formCampaign.templateType === 2"
                        type="text"
                        @click.stop="
                          deleteItem(index, item.id)
                        "
                        icon="el-icon-delete"
                        circle
                      ></el-button>
                    </div>
                  </div>
                  <div v-else-if="!tempLoading" style="color: red">
                    {{formCampaign.templateType === 2? '没有自定义模板': ''}}
                    {{formCampaign.templateType === 1? '没有系统模板': ''}}
                    
                  </div>
                </div>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer" style="margin-top: 0">
              <el-button @click="dialogCampaignVisible = false">取 消</el-button>
              <el-button type="primary" @click="addCampaign">确 定</el-button>
            </div>
          </el-dialog>
          <!-- 活动名称修改 -->
          <el-dialog
            title="修改活动名称"
            :visible.sync="dialogFormVisible"
            :close-on-click-modal="false"
          >
            <el-form :model="formName" :rules="rules" ref="formName">
              <el-form-item
                label="活动名称"
                prop="activityName"
                :label-width="formLabelWidth"
              >
                <el-input
                  v-model="formName.activityName"
                  autocomplete="off"
                  maxlength="20"
                >
                  <span
                    slot="suffix"
                    style="
                      position: relative;
                      bottom: 0;
                      right: 0;
                      color: rgba(153, 153, 153, 1);
                      margin-right: 10px;
                    "
                    >{{ formName.activityName.length }}/20</span
                  >
                </el-input>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="dialogFormVisible = false">取 消</el-button>
              <el-button type="primary" @click="updateName">确 定</el-button>
            </div>
          </el-dialog>
          <!-- 另存为模板 -->
          <el-dialog
            title="另存为模板"
            :visible.sync="dialogTemplateFormVisible"
            :close-on-click-modal="false"
          >
            <el-form :model="formTemplate" :rules="rulest" ref="formTemplate">
              <el-form-item
                label="模板名称"
                prop="name"
                :label-width="formLabelWidth"
              >
                <el-input
                  v-model="formTemplate.name"
                  autocomplete="off"
                  maxlength="20"
                >
                  <span
                    slot="suffix"
                    style="
                      position: relative;
                      bottom: 0;
                      right: 0;
                      color: rgba(153, 153, 153, 1);
                      margin-right: 10px;
                    "
                    >{{ formTemplate.name.length }}/20</span
                  >
                </el-input>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="dialogTemplateFormVisible = false"
                >取 消</el-button
              >
              <el-button type="primary" v-loading="saveTemplateLoading" :disabled="saveTemplateLoading" @click="saveAsTemplate" v-preventReClick
                >确 定</el-button
              >
            </div>
          </el-dialog>
          <!-- 统计 -->
          <!-- <el-dialog
            title="统计分析"
            width="1120px"
            :visible.sync="dialogStatisticsVisible"
            :close-on-click-modal="false"
            @close="formClose"
          >
            <el-form :inline="true" :model="msgQueryForm">
              <el-form-item label="手机号" style="margin-right: 10px">
                <el-input
                  style="width: 120px;"
                  v-model="msgQueryForm.mobile"
                  placeholder="手机号码"
                ></el-input>
              </el-form-item>
              <el-form-item label="状态" style="margin-right: 10px">
                <el-select
                  style="width: 140px;"
                  v-model="msgQueryForm.status"
                  placeholder="类型"
                >
                  <el-option
                    v-for="(item, index) in types"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="接收状态"
                v-if="isReport"
                style="margin-right: 10px"
              >
                <el-select
                  style="width: 100px;"
                  v-model="msgQueryForm.report"
                  placeholder="接收状态"
                >
                  <el-option
                    v-for="(item, index) in reports"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="发送时间" style="margin-right: 10px">
                <el-date-picker
                  clearable
                  v-model="tempTime"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :default-time="['00:00:00', '23:59:59']"
                  style="width: 370px;"
                  size="small"
                  class="picker"
                ></el-date-picker>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="onSubmit">查询</el-button>
              </el-form-item>
            </el-form>
            <el-table :data="msgData" style="width: 100%" v-loading="tableLoading">
              <el-table-column
                align="center"
                prop="mobile"
                label="手机号"
                width="120"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="sendTime"
                label="发送时间"
                width="160"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="smsNumber"
                label="扣费条数"
                width="80"
              >
              </el-table-column>
              <el-table-column
                align="center"
                prop="statusDesc"
                label="状态"
                width="130"
              >
              </el-table-column>
              <el-table-column
                v-if="isReport"
                align="center"
                prop="report"
                label="接收状态"
                width="80"
              >
              </el-table-column>
              <el-table-column align="content" prop="content" label="发送内容">
              </el-table-column>
            </el-table>
            <el-pagination
              background
              style="text-align:right"
              small
              layout="total, prev, pager, next"
              :page-size="msgQueryForm.pageSize"
              :current-page.sync="msgQueryForm.pageNum"
              :total="msgQueryForm.recordCount"
              @current-change="msgCurrentChange"
            >
            </el-pagination>
          </el-dialog> -->
        </div>
      </div>
    </div>
     <!-- 效果分析新版页面 -->
    <effect-analysis-x
      v-if="showEffectAnalysisX"
      :officialObj="officialObj"
      @onClose="goBackHomeX"
    >
    </effect-analysis-x>
  </div>
</template>

<script>
import { mapState } from "vuex";
import smsRecordForm from "./smsRecordForm";
import effectMarketForm from "./effectMarketForm";
import effectAnalysisX from '../../components/effect-analysis-x.vue';
import {
  getIntelligentList,
  updateIntelligent,
  getAllTemplateList,
  delCustomizeT,
  addSmartMarketing,
  saveTemplate,
  delSmartMarketing,
} from "@/api/intelligentMarket/index";
export default {
  name: "",
  components: {
    smsRecordForm,
    effectMarketForm,
    effectAnalysisX
  },
  data() {
    return {
      //新建活动
      isShowAll: false, // 是否显示全部
      officialObj: {},
      showEffectAnalysisX: false, // 新版效果分析
      dialogCampaignVisible: false,
      tempLoading: false,
      formLabelWidth: "80px",
      templateList: [
      ],
      formCampaign: {
        activityName: "",
        templateType: "",
        templateId: "",
      },
      rules: {
        activityName: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
          {
            min: 1,
            max: 20,
            message: "长度在 1 到 20 个字符",
            trigger: "blur",
          },
        ],
      },
      rulest: {
        name: [
          { required: true, message: "请输入模板名称", trigger: "blur" },
          {
            min: 1,
            max: 20,
            message: "长度在 1 到 20 个字符",
            trigger: "blur",
          },
        ],
      },
      changeIndex: "", //用于标示变化中的数据下标
      //活动名称修改
      dialogFormVisible: false,
      formName: {
        smartMarketingId: "",
        templateId: "",
        activityName: "",
      },
      //中部切换栏
      activeName: "first",
      //表格内容
      tableData: [],
      //分页栏
      queryForm: {
        current: 1,
        size: 10,
        webActivityStatus: "", // 0.设计中， 1.执行中， 2.已结束
        activityName: "",
        total: 0,
      },
      activeStatus: "-1",
      tableLoading: false,
      tabIndex: 1, // 1.智能营销 2.短信记录 3.营销效果
      formData: {
        activityName: "",
      },
      dialogTemplateFormVisible: false,
      saveTemplateLoading: false,
      formTemplate: {
        intelligentMarketingId: "",
        name: "",
      },
      itemStateType: '', // 活动模板的id
      recommondList: [], // 推荐模板列表
    };
  },
  mounted() {
    this.queryList();
    this.getSysAllTemplate();
  },
  computed: {
    ...mapState({
      globalBG: "globalBG",
    }),
  },
  filters: {
    showExecution(val) {
      var list = ["", "定时执行", "周期执行"];
      return list[val];
    },
    showStatus(val) {
      var res = "";
      if (val === 0 || val === 3 || val === 4) {
        res = "设计中";
      } else if (val === 1 || val === 5 || val === 6) {
        res = "执行中";
      } else if (val === 2) {
        res = "已结束";
      }
      return res;
    },
  },
  methods: {
    getSysAllTemplate() {
      // 获取系统模板
      var param = {
        templateType: 1
      }
      getAllTemplateList(param).then(res => {
        this.recommondList = res.data
      })
    },

    goBackHomeX(val) {
      this.showEffectAnalysisX = false;
    },

    showEffectX(val) {
      this.showEffectAnalysisX = true,
      this.officialObj = val;
    },

    // 查询表格数据
    queryList(val) {
      let that = this;
      let obj = {
        activityName: that.queryForm.activityName,
        current: that.queryForm.current,
        size: that.queryForm.size,
        webActivityStatus: that.queryForm.webActivityStatus,
      };
      this.tableLoading = true;
      getIntelligentList(obj).then((res) => {
        this.tableLoading = false;
        if (res.code == "1") {
          this.tableData = res.data.records;
          this.queryForm.total = res.data.total;
        } else {
          this.$message.error(res.message);
        }
      });
    },

    // 保存模板
    saveAsTemplate() {
      this.$refs.formTemplate.validate((valid) => {
        if (valid) {
          this.saveTemplateLoading = true;
          saveTemplate(this.$data.formTemplate).then((response) => {
            this.saveTemplateLoading = false;
            if (response.code === 1) {
              this.$message.success("模板添加成功");
              this.$data.dialogTemplateFormVisible = false;
              this.$data.formTemplate.name = "";
            }
          });
        } else {
          return false;
        }
      });
    },

    //新建活动
    newFormClose() {
      //表单重置
      this.$refs.formCampaign.resetFields();
      this.$data.formCampaign = {
        activityName: "",
        templateType: "",
        type: "",
        templateId: "",
      };
      this.$data.templateList = [];
    },
    //自定义模板删除
    deleteItem(i, id) {
      delCustomizeT(id).then(res => {
        if (res.code === 1) {
          this.$message.success('删除成功！')
          this.$data.templateList.splice(i, 1)
        }
      })
    },
    //添加列表模板类型变化
    typeTemplateChange(value) {
      if (value != "") {
        this.$data.formCampaign.templateId = "";
        this.$data.tempLoading = true;
        var param = {
          templateType: this.$data.formCampaign.templateType
        }
        getAllTemplateList(param).then(res => {
          this.$data.templateList = res.data;
          this.$data.tempLoading = false;
        })
      } else {
        this.$data.formCampaign.templateId = "";
        this.$data.templateList = [];
      }
    },
    //选择模板
    selectTemplate(val) {
      //触发视图更新，且能新增属性
      this.$set(
        this.$data,
        "templateList",
        this.$data.templateList.map((item, i) => {
          if (i === val) {
            item.selected = true;
            this.$data.formCampaign.templateId = item.id;
          } else {
            item.selected = false;
          }
          return item;
        })
      );
    },
    //添加列表数据
    addCampaign() {
      this.$refs.formCampaign.validate((valid) => {
        if (valid) {
          let data = JSON.parse(JSON.stringify(this.$data.formCampaign));
          if (data.templateType !== "" && data.templateId === "") {
            this.$message.error("请选择活动模板！");
            return false;
          }
          //开始-------暂时跳转，后边删除
          // let routeUrl = this.$router.resolve({
          //   name: "miDetal",
          //   query: { id: 11111, type: "Edit" },
          // });
          // window.open(routeUrl.href, "_blank");
          //结束-------
          this.dialogCampaignVisible = false;
          // delete data.type;
          addSmartMarketing(data).then(response => {
            if (response.code === 1) {
              let routeUrl = this.$router.resolve({
                 name: 'miDetal',
                query: {id: response.data, type: 'Edit'}
              });
              this.dialogCampaignVisible = false
              window.open(routeUrl.href, '_blank');
            }
          })
        } else {
          return false;
        }
      });
    },
    handleClick(tab, event) {
      // console.log(tab);
      var list = ["", "0", "1", "2"];
      var index = +this.activeStatus + 1;
      this.queryForm.webActivityStatus = list[index];
      this.queryList();
    },
    handleSwitch(index) {
      this.tabIndex = index;
    },
    newBtn(index) {
      this.dialogCampaignVisible = true;
      if (index !== null && index !== undefined) {
        this.formCampaign.templateType = 1;
        this.$data.templateList = this.recommondList;
        this.selectTemplate(index)
      }
    },
    handleSearch() {
      this.queryForm.current = 1;
      this.queryList();
    },
    //表格修改名称-行
    handleName(index, row) {
      this.formName.id = row.id;
      this.formName.activityName = row.activityName;
      this.changeIndex = index;
      this.dialogFormVisible = true;
    },
    //表格修改名称-行-确认
    updateName() {
      this.$refs.formName.validate((valid) => {
        this.$data.dialogFormVisible = false;
        if (valid) {
          updateIntelligent(this.$data.formName).then((response) => {
            if (response.code === 1) {
              this.$message.success("修改成功！");
              this.$data.tableData[
                this.$data.changeIndex
              ].activityName = this.$data.formName.activityName;
              this.$data.dialogFormVisible = false;
              this.$refs.formName.resetFields();
            }
          });
        } else {
          return false;
        }
      });
    },
    //查看
    handleView(index, row) {
      let routeUrl = this.$router.resolve({
        name: "miDetal",
        query: { id: row.id, type: "Edit", status: row.activityStatus },
      });
      window.open(routeUrl.href, "_blank");
    },
    //另存
    handleSaveAs(index, row) {
      this.$data.formTemplate.intelligentMarketingId = row.id;
      this.$data.dialogTemplateFormVisible = true;
    },
    //删除
    handleDelete(index, row) {
      this.$confirm("您确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delSmartMarketing(row.id).then(
            (res) => {
              if (res.code === 1) {
                this.$message.success("删除成功");
                this.queryList(); // 重新查询表格
              }else{
                this.$message.error(res.data.message)
              }
            }
          );
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
    },
    //分页
    queryCurrentChange(val) {
      this.queryForm.current = val;
      this.queryList();
    },
  },
};
</script>
<style scoped lang="scss">
/deep/ .el-tabs__header::after{
  // display: none;
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 2px;
    background-color: #E4E7ED;
    z-index: 1;
  background-color: #E4E7ED;
  height: 1px;
}
/deep/ .el-tabs__nav-wrap::after{
  display: none;
}
/deep/ .el-dialog__body{
  padding-bottom: 0;
}
/deep/ .el-tabs__item{
  padding: 0 16px;
}
.recom-template{
  margin: 20px 28px 0  28px;
  .recom-title{
    background-color: #FAFAFA;
    height: 32px;
    line-height: 32px;
    padding-right: 12px;
    .divison{
      vertical-align: middle;
      border-radius: 3px;
      width: 3px;
      height: 14px;
      background-color: #FE4D45;
      display: inline-block;
      margin: auto 4px auto 12px;
    }
    .name{
      font-size: 14px;
      font-weight: 500;
      line-height: 20px;
      color: #333;
    }
    .open{
      color: #7F85E9;
      font-size: 12px;
      font-weight: 400px;
      float: right;
      cursor: pointer;
    }
  }
  .recom-list{
    overflow: hidden;
    color: #333;
    .recom-item{
      border: 1px solid #EEEEEE;
      border-radius: 4px;
      display: inline-block;
      width: 320px;
      margin-right: 7px;
      margin-top: 12px;
      &:hover{
        border: 1px solid rgba(254, 77, 69, 0.5019607843137255);
      }
      .recom-content{
        height: 113px;
      }
      .img-wrap{
        display: inline-block;
        margin: 17px 12px 0 20px;
        img{
          width: 60px;
          height: 60px;
          border-radius: 50%;
          overflow: hidden;
        }
      }
      .text-info{
        display: inline-block;
        padding-top: 17px;
        vertical-align: top;
        .title{
          font-size: 16px;
          font-weight: 500;
          padding-bottom: 6px;
        }
        .info{
          font-size: 13px;
          color: #666;
          width: 217px;
          text-overflow: ellipsis;
          line-height: 18px;
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
        }
      }
      .create-btn{
        cursor: pointer;
        text-align: center;
        line-height: 44px;
        font-size: 14px;
        color: #666;
        border-top: 1px solid #eee;
        transition: background-color 0.2s;
        background-color: #fff;
        &:hover{
          background-color: #FE4D45;
          border-radius: 0px 0px 4px 4px;
          color: #fff;
        }
      }
    }
  }
}
/deep/.el-tabs__nav-wrap {
  width: 275px;
}
.intelligentBox {
  margin: 11px 20px;
  min-width: 1130px;
  .tab-line {
    font-size: 14px;
    color: #666666;
    border-bottom: 1px solid #dddddd;
    margin: 20px 28px 0 28px;
    .tab-item {
      text-align: center;
      width: 106px;
      height: 36px;
      line-height: 36px;
      display: inline-block;
      position: relative;
      cursor: pointer;
      margin-right: 2px;
      border: 1px solid #dddddd;
      border-bottom: none;
      span {
        position: absolute;
        width: 100%;
        left: 50%;
        height: 2px;
        transform: translateX(-50%);
        bottom: -2px;
        display: none;
      }
      &.active {
        border-top: 2px;
        span {
          display: block;
          background: #fff;
        }
      }
    }
  }
  .tab_item_box {
    padding: 20px 27px 20px;
    .status_btn {
      font-size: 14px;
      width: 98px;
      font-size: 14px;
      height: 32px;
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff;
      &:hover {
        color: #fff;
        border: 1px solid #fff;
        background-color: #fe4d45;
      }
    }
    .status_btn2 {
      margin-left: 8px;
      color: #666666;
      font-size: 14px;
      border: 1px solid #dddddd;
      background-color: #fff;
      &:hover {
        color: #fe4d45;
        border: 1px solid #fe4d45;
        background-color: #fff4f4;
      }
    }
    .search_item {
      display: inline-block;
      margin-right: 79px;
      margin-bottom: 16px;
      color: #333;
    }
  }
  .tab_item_box_one {
    padding: 0px 27px 10px 28px;
  }
  .create_btn3 {
    width: 98px;
    height: 32px;
    opacity: 1;
    border-radius: 3px;
    display: inline-block;
    text-align: center;
    line-height: 32px;
    font-size: 14px;
    font-weight: 400;
    cursor: pointer;
    color: #ffffff;
    background-color: #fe4d45;
    &:hover {
      color: #fff;
      opacity: 0.9;
      background-color: #fe4d45;
    }
  }
  .right_allBtn {
    float: right;
    color: #333;
    font-size: 14px;
  }
  .table-center {
    margin: 2px 28px 10px 28px;
    padding-bottom: 20px;
  }
  .el-icon-edit-outline {
    cursor: pointer;
  }
  .table-header__bg {
    background-color: #fafafa;
    & th {
      background-color: transparent;
    }
  }
}
.box-shadow {
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  background: #fff;
}
.templist {
  border: 1px solid #e6e6e6;
 
  border-right: none;
  max-height: 250px;
  overflow-x: hidden;
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 5px;
  }
  &::-webkit-scrollbar-track {
    // box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.2) inset;
  }
  &::-webkit-scrollbar-thumb {
    min-height: 20px;
    background-clip: content-box;
    box-shadow: 0 0 0 5px rgba(0, 0, 0, 0.2) inset;
  }
  &::-webkit-scrollbar-corner {
    background: transparent;
  }
  .titem {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 5px 15px;
    border-bottom: 1px solid #EBEEF5;
    &.active,
    &.active:hover {
      // background-color: #256FFA;
      span {
        color: #fff;
      }
      .el-button--text {
        color: #fff;
      }
    }
    &:hover {
      background-color: #F5F7FA;
    }
    &:last-child {
      border-bottom: none;
    }
  }
}
.operation {
  cursor: pointer;
  color: #7f85e9;
  &:hover {
    color: #fe4d45;
  }
}
</style>
